// @ts-nocheck
import { TabProps } from "@insite/mobius/Tab";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const tab: Styleguide["tab"] = {
    defaultProps: {
        typographyProps: {
            forwardAs: "h3",
            css: css`
                font-size: ${x => x.theme.design.typography.size.base /* Store Custom Code */};
            `,
        },
        css: css<TabProps>`
            ${focusStyles(true)}
            cursor: pointer;
            border-bottom: ${pxToRem(2)} solid ${getColor("common.border")};
            transition: ${transitionHoverStyles("color", "border-color")};
            /* Store Custom Code - Start */
            ${breakpointValues([pxToRem(10, 20), pxToRem(10, 30), pxToRem(12, 40), null, pxToRem(15, 70)], "padding")}
            /* Store Custom Code - End */

            &:hover, &[aria-selected="true"] {
                border-bottom: ${pxToRem(6)} solid ${getColor("primary") /* Store Custom Code */};
                color: ${getColor("primary")};
                /* Store Custom Code - Start */
                font-weight: ${x => x.theme.design.typography.weight.bold};
                /* Store Custom Code - End */
            }
        `,
    },
    groupDefaultProps: {
        cssOverrides: {
            wrapper: css`
                padding: 0;

                > div /* contents wrapper */ {
                    width: 100%;
                }
            `,
            tabContent: css`
                border: none;
                padding: 0;
                ${breakpointValues(pxToRemArray([26, 30, 36, null, 50]), "margin-top")}
            `,
            tabGroup: css`
                flex-wrap: wrap;
                justify-content: flex-start; /* Store Custom Code */
                padding: 0;
            `,
        },
    },
};

export default tab;
